import type { JsonTransactionContract } from "@core/ports/json-storage";
import { JsonWriteConflictError } from "@core/ports/json-storage";

import type { IndexedDbClient, IndexedDbOperation } from "./IndexedDbClient.ts";

export class IndexedDbTransaction implements JsonTransactionContract {
  public readonly __typeTag = "JsonTransactionContract";

  private readonly indexedDb: IndexedDbClient;

  // @mutable
  private readonly operations: IndexedDbOperation[] = [];

  public constructor({ indexedDb }: { readonly indexedDb: IndexedDbClient }) {
    this.indexedDb = indexedDb;
  }

  public add(operation: IndexedDbOperation): void {
    this.operations.push(operation);
  }

  /**
   * @throws {JsonWriteConflictError} If any operation's condition fails.
   */
  public async commit(): Promise<void> {
    const { committed } = await this.indexedDb.transact(this.operations);

    if (!committed) {
      throw new JsonWriteConflictError(
        "A write condition failed, so the transaction wrote nothing",
      );
    }
  }
}
